import { render, staticRenderFns } from "./VideoOnVideoLayout.vue?vue&type=template&id=7b371eaf&"
import script from "./VideoOnVideoLayout.vue?vue&type=script&lang=ts&"
export * from "./VideoOnVideoLayout.vue?vue&type=script&lang=ts&"
import style0 from "./VideoOnVideoLayout.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports